import DOMPurify from "dompurify";

function inline(text) {
  return text
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(?=\S)([^*]+?)(?<=\S)\*/g, "<em>$1</em>")
    .replace(/`(.+?)`/g, '<code class="rounded bg-white/10 px-1 font-mono text-xs">$1</code>');
}

// Line-based markdown -> sanitized HTML. When `clickable`, checkbox glyphs carry a
// data-check-line index so the preview can toggle them.
export function renderNotes(md, clickable = false) {
  const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const lines = esc(md || "").split("\n");
  const out = [];
  let list = null;
  const closeList = () => { if (list) { out.push(`</${list}>`); list = null; } };
  const openList = (t) => { if (list !== t) { closeList(); out.push(`<${t} class="ml-4 my-1 ${t === "ul" ? "list-disc" : "list-decimal"}">`); list = t; } };

  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    let m;
    if ((m = line.match(/^###\s+(.*)/))) { closeList(); out.push(`<h3 class="font-display text-base mt-2 mb-1">${inline(m[1])}</h3>`); }
    else if ((m = line.match(/^##\s+(.*)/))) { closeList(); out.push(`<h2 class="font-display text-lg mt-2 mb-1">${inline(m[1])}</h2>`); }
    else if ((m = line.match(/^#\s+(.*)/))) { closeList(); out.push(`<h1 class="font-display text-xl mt-2 mb-1">${inline(m[1])}</h1>`); }
    else if (/^---+$/.test(line)) { closeList(); out.push('<hr class="my-3 border-white/10"/>'); }
    else if ((m = line.match(/^-\s+\[( |x|X)\]\s+(.*)/))) {
      openList("ul");
      const done = m[1].toLowerCase() === "x";
      const glyphAttrs = clickable ? ` role="checkbox" aria-checked="${done}" tabindex="0" data-check-line="${i}" class="mt-px cursor-pointer select-none ${done ? "text-grn" : "text-muted"}"` : ` class="mt-px select-none ${done ? "text-grn" : "text-muted"}"`;
      out.push(`<li class="list-none -ml-4 flex items-start gap-1.5"><span${glyphAttrs}>${done ? "☑" : "☐"}</span><span class="${done ? "opacity-60 line-through" : ""}">${inline(m[2])}</span></li>`);
    }
    else if ((m = line.match(/^\d+\.\s+(.*)/))) { openList("ol"); out.push(`<li>${inline(m[1])}</li>`); }
    else if ((m = line.match(/^[-*]\s+(.*)/))) { openList("ul"); out.push(`<li>${inline(m[1])}</li>`); }
    else if (line.trim() === "") { closeList(); out.push("<br/>"); }
    else { closeList(); out.push(`<p class="my-1">${inline(line)}</p>`); }
  });
  closeList();
  return DOMPurify.sanitize(out.join(""), {
    ALLOWED_TAGS: ["h1", "h2", "h3", "hr", "ul", "ol", "li", "p", "span", "strong", "em", "code", "br"],
    ALLOWED_ATTR: ["class", "role", "tabindex", "aria-checked", "data-check-line"],
  });
}
